import { GameConfiguratorSingleton } from '@services/GameConfiguratorSingleton';
var ComponentWithPosition = /** @class */ (function () {
    function ComponentWithPosition(x, y, size) {
        this._x = x;
        this._y = y;
        this._width = size;
        this._height = size;
        this._gameConfigurator = GameConfiguratorSingleton.getInstance();
    }
    Object.defineProperty(ComponentWithPosition.prototype, "width", {
        get: function () {
            return this._width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentWithPosition.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentWithPosition.prototype, "x", {
        get: function () {
            return this._x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentWithPosition.prototype, "y", {
        get: function () {
            return this._y;
        },
        enumerable: false,
        configurable: true
    });
    return ComponentWithPosition;
}());
export { ComponentWithPosition };
